import {
  GetIssuesStatisticsResponseDto,
  useApi,
} from '@issuemanager/api-client';
import { ExtendedAxiosError } from '@issuemanager/apps/client/hooks';
import { useQuery } from '@tanstack/react-query';

export function useStatistics() {
  const api = useApi();

  return useQuery<GetIssuesStatisticsResponseDto, ExtendedAxiosError>({
    queryKey: ['statistics'],
    queryFn: () => api.issuesApi.getStatistics().then((r) => r.data),
    meta: {
      handleError: true,
    },
  });
}
